import React from 'react';
import { ImageFadeIn } from '../components/animations/ImageFadeIn';
import { ScrollReveal } from '../components/animations/ScrollReveal';
import { useDonateByMail } from '../contexts/DonateByMailContext';
import { DollarSign, Building, Share2, Heart, Shield, Users } from 'lucide-react';
const SupportPage = () => {
  const {
    openDonateByMail
  } = useDonateByMail();
  return <div className="w-full min-h-screen bg-white" data-id="element-968" data-mp="65brjqdqrq75">
      {/* Hero Section */}
      <div className="relative min-h-[60vh] flex items-center" data-id="element-969" data-mp="638redivkgop">
        <div className="absolute inset-0 z-0" data-id="element-970" data-mp="1838zooolk5d">
          <ImageFadeIn src="https://uploadthingy.s3.us-west-1.amazonaws.com/jop9zBgRujeWdeTtyMQTQf/Screenshot_2025-06-06_at_5.11.07_PM.png" alt="Civilians training together" className="w-full h-full object-cover" data-id="element-971" data-mp="fv4rfu4iugvk" />
          <div className="absolute inset-0 bg-black/60" data-id="element-972" data-mp="3jin9lajrgem6"></div>
        </div>
        <div className="relative z-10 w-full pt-36 sm:pt-52 md:pt-56 pb-16 sm:pb-20" data-id="element-973" data-mp="3ekd9qmn3cpu8">
          <div className="max-w-5xl mx-auto px-4 sm:px-6 text-center" data-id="element-974" data-mp="34y517jt89fwx">
            <h1 className="text-3xl sm:text-5xl md:text-6xl font-bold text-white tracking-tight mb-4 sm:mb-6" data-id="element-975" data-mp="39wg8bms51cbg">
              Support Our Mission
            </h1>
            <p className="text-lg sm:text-xl md:text-2xl text-white/90 max-w-3xl mx-auto font-light leading-relaxed" data-id="element-976" data-mp="3enycejpgjt0n">
              Help us build a safer, more resilient Israel through civilian
              training and preparedness
            </p>
          </div>
        </div>
      </div>
      {/* Why Your Support Matters */}
      <ScrollReveal animation="fade" data-id="element-977" data-mp="2uz5qzwstdc7t">
        <div className="py-16 sm:py-24 bg-white" data-id="element-978" data-mp="2uy4f5q3z4lp1">
          <div className="max-w-5xl mx-auto px-4 sm:px-6" data-id="element-979" data-mp="2v1iip1odj0y2">
            <div className="text-center mb-16" data-id="element-980" data-mp="2zz1ttspryxls">
              <div className="inline-flex items-center justify-center mb-6" data-id="element-981" data-mp="a8yimuwu1qaw">
                <Heart className="w-8 h-8 text-red-500 mr-3" data-id="element-982" data-mp="ab191g1wdlg5" />
                <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 tracking-tight" data-id="element-983" data-mp="f704fnln83q2">
                  Why Your Support Matters
                </h2>
              </div>
              <p className="text-xl text-gray-700 max-w-3xl mx-auto" data-id="element-984" data-mp="27a44ki0k2ebm">
                Protecting Israeli families is critical to the survival of
                Israel's present and future. 100% of all donations go directly
                to training famililes in Samaria.
              </p>
            </div>
            <ScrollReveal animation="scale" delay={0.2} data-id="element-985" data-mp="1sjwvuu0co9o4">
              <div className="mb-16" data-id="element-986" data-mp="1sibyyxqkcen3">
                <div className="relative rounded-xl overflow-hidden" data-id="element-987" data-mp="1nmd54umgu4fa">
                  <ImageFadeIn src="https://uploadthingy.s3.us-west-1.amazonaws.com/gPbz3hZ76mcFrXSSdUotxi/Screenshot_2025-06-06_at_5.10.59_PM.png" alt="Civilians practicing emergency response techniques" className="w-full h-auto" data-id="element-988" data-mp="22ahqy7gtew2a" />
                  <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-6 sm:p-10" data-id="element-989" data-mp="14vdja2a9paq8">
                    <p className="text-white text-lg sm:text-xl font-light max-w-3xl" data-id="element-990" data-mp="3gheclal22b48">
                      When minutes matter and help is far away, trained
                      civilians become the first and most critical line of
                      defense for their families and communities.
                    </p>
                  </div>
                </div>
              </div>
            </ScrollReveal>
            <ScrollReveal animation="slide-up" data-id="element-991" data-mp="342md34vuge4">
              <div className="prose prose-lg max-w-none text-gray-700" data-id="element-992" data-mp="82dw7dv6gqwc"></div>
            </ScrollReveal>
          </div>
        </div>
      </ScrollReveal>
      {/* Immediate Funding Needs */}
      <ScrollReveal animation="fade" data-id="element-993" data-mp="3v7bw3d81icn3">
        <div className="py-16 sm:py-24 bg-blue-50" data-id="element-994" data-mp="3v6ak96j79m4b">
          <div className="max-w-5xl mx-auto px-4 sm:px-6" data-id="element-995" data-mp="3v96k50elykve">
            <div className="text-center mb-16" data-id="element-996" data-mp="2esao86nh6gmc">
              <div className="inline-flex items-center justify-center mb-6" data-id="element-997" data-mp="2js6t083zyc2y">
                <Shield className="w-8 h-8 text-blue-500 mr-3" data-id="element-998" data-mp="2jq3t8wd1l4l1" />
                <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 tracking-tight" data-id="element-999" data-mp="2z2lkv5nmgsf8">
                  Our Immediate Needs
                </h2>
              </div>
              <p className="text-xl text-gray-700 max-w-3xl mx-auto" data-id="element-1000" data-mp="2pbije2qs6bff">
                We're working to protect vulnerable communities now while
                building for the future
              </p>
            </div>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12" data-id="element-1001" data-mp="3hzmr0tswwykr">
              <ScrollReveal animation="slide-left" delay={0.1} data-id="element-1002" data-mp="3d1uoz6yjzw2u">
                <div className="bg-white p-8 sm:p-10 rounded-xl shadow-sm border border-gray-100 relative overflow-hidden" data-id="element-1003" data-mp="3d2eaexnex2lm">
                  <div className="absolute top-0 right-0 w-32 h-32 -mt-10 -mr-10 bg-blue-100 rounded-full opacity-50" data-id="element-1004" data-mp="340wtjd26kwvv"></div>
                  <div className="relative" data-id="element-1005" data-mp="1xl4c4pd9vxcq">
                    <div className="text-3xl sm:text-4xl font-bold text-blue-600 mb-4" data-id="element-1006" data-mp="1xm5p4zdumtx3">
                      $750,000
                    </div>
                    <h3 className="text-xl font-semibold text-gray-900 mb-6" data-id="element-1007" data-mp="848ryv4pbjlj">
                      Immediate Community Training
                    </h3>
                    <div className="prose prose-lg text-gray-700" data-id="element-1008" data-mp="d31y22hns8bo">
                      <p data-id="element-1009" data-mp="h3ca9ww1nuyz">
                        While we work to build our permanent training center,
                        vulnerable communities need training now. Currently we
                        have one system with one full time trainer helping
                        prepare these communities. The need for this training is
                        urgent and requires additional trainers and equipment.
                        Additional funding will allow us to:
                      </p>
                    </div>
                    <ul className="mt-6 space-y-4" data-id="element-1010" data-mp="14t6ks7sw57g2">
                      <li className="flex items-start" data-id="element-1011" data-mp="32kj2amps7tsx">
                        <div className="flex-shrink-0 w-6 h-6 rounded-full bg-blue-100 flex items-center justify-center mt-1 mr-3" data-id="element-1012" data-mp="32m3wgb86paq9">
                          <span className="text-blue-600 text-sm font-semibold" data-id="element-1013" data-mp="dqcjayl2w9c5">
                            1
                          </span>
                        </div>
                        <span className="text-gray-700" data-id="element-1014" data-mp="8u44xnepgk61">
                          Hire 2 more full time trainers to enhance training
                          capability throughout the region
                        </span>
                      </li>
                      <li className="flex items-start" data-id="element-1015" data-mp="woousqzgpvaw">
                        <div className="flex-shrink-0 w-6 h-6 rounded-full bg-blue-100 flex items-center justify-center mt-1 mr-3" data-id="element-1016" data-mp="rqn9dzekdjw9">
                          <span className="text-blue-600 text-sm font-semibold" data-id="element-1017" data-mp="16ei2vi0ebsae">
                            2
                          </span>
                        </div>
                        <span className="text-gray-700" data-id="element-1018" data-mp="1ffydnqv4hwf5">
                          Deploy 2 more portable MILO Range simulators to train
                          high-risk communities
                        </span>
                      </li>
                      <li className="flex items-start" data-id="element-1019" data-mp="1u48478chdaen">
                        <div className="flex-shrink-0 w-6 h-6 rounded-full bg-blue-100 flex items-center justify-center mt-1 mr-3" data-id="element-1020" data-mp="1z1rjmbkwzt86">
                          <span className="text-blue-600 text-sm font-semibold" data-id="element-1021" data-mp="1l1gsd7fp0cmh">
                            3
                          </span>
                        </div>
                        <span className="text-gray-700" data-id="element-1022" data-mp="1bbx75v4ic6og">
                          Purchase 2 trauma manikins and medical supplies for
                          training
                        </span>
                      </li>
                      <li className="flex items-start" data-id="element-1023" data-mp="11fkft3wfq4wv">
                        <div className="flex-shrink-0 w-6 h-6 rounded-full bg-blue-100 flex items-center justify-center mt-1 mr-3" data-id="element-1024" data-mp="16d2s949nv29m">
                          <span className="text-blue-600 text-sm font-semibold" data-id="element-1025" data-mp="sembsllzxxea">
                            4
                          </span>
                        </div>
                        <span className="text-gray-700" data-id="element-1026" data-mp="1cufg9f8ctph0">
                          Fund filming of approximately 25 realistic scenarios
                          in the region for use on the MILO simulator training
                          system
                        </span>
                      </li>
                      <li className="flex items-start" data-id="element-1027" data-mp="yvfq235712iq">
                        <div className="flex-shrink-0 w-6 h-6 rounded-full bg-blue-100 flex items-center justify-center mt-1 mr-3" data-id="element-1028" data-mp="ywz6btqundki">
                          <span className="text-blue-600 text-sm font-semibold" data-id="element-1029" data-mp="p5cxg41zhqkx">
                            5
                          </span>
                        </div>
                        <span className="text-gray-700" data-id="element-1030" data-mp="k3nkujz454uq">
                          Construct two weapons training ranges (one rifle and
                          one pistol) for exclusive civilian training
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
              </ScrollReveal>
              <ScrollReveal animation="slide-right" delay={0.1} data-id="element-1031" data-mp="2hssqouswkb95">
                <div className="bg-white p-8 sm:p-10 rounded-xl shadow-sm border border-gray-100 relative overflow-hidden" data-id="element-1032" data-mp="2msf537kgvxjj">
                  <div className="absolute top-0 right-0 w-32 h-32 -mt-10 -mr-10 bg-blue-100 rounded-full opacity-50" data-id="element-1033" data-mp="2qvbrl9d4odsr"></div>
                  <div className="relative" data-id="element-1034" data-mp="2vstuai0jxwsb">
                    <div className="text-3xl sm:text-4xl font-bold text-blue-600 mb-4" data-id="element-1035" data-mp="1z3cq67h7wisq">
                      $14.1 Million
                    </div>
                    <h3 className="text-xl font-semibold text-gray-900 mb-6" data-id="element-1036" data-mp="2357mexkak5zn">
                      Complete Training Center
                    </h3>
                    <div className="prose prose-lg text-gray-700" data-id="element-1037" data-mp="2cu7s0ztatzmt">
                      <p data-id="element-1038" data-mp="2cwkhrz5ateaf">
                        This funding will allow us to complete construction of
                        the Samaria Regional Training Center and launch
                        full-scale operations, including:
                      </p>
                    </div>
                    <ul className="mt-6 space-y-4" data-id="element-1039" data-mp="lxtiapz0aqr2">
                      <li className="flex items-start" data-id="element-1040" data-mp="pz58awlsldzs">
                        <div className="flex-shrink-0 w-6 h-6 rounded-full bg-blue-100 flex items-center justify-center mt-1 mr-3" data-id="element-1041" data-mp="q1rfuw8onti0">
                          <span className="text-blue-600 text-sm font-semibold" data-id="element-1042" data-mp="zxm88j2pl2xz">
                            1
                          </span>
                        </div>
                        <span className="text-gray-700" data-id="element-1043" data-mp="2899vgmtzkjk">
                          Complete construction of all training facilities and
                          ranges
                        </span>
                      </li>
                      <li className="flex items-start" data-id="element-1044" data-mp="gzi82e4sue8b">
                        <div className="flex-shrink-0 w-6 h-6 rounded-full bg-blue-100 flex items-center justify-center mt-1 mr-3" data-id="element-1045" data-mp="h0b9czkzobj2">
                          <span className="text-blue-600 text-sm font-semibold" data-id="element-1046" data-mp="3kntmu2pa9l3c">
                            2
                          </span>
                        </div>
                        <span className="text-gray-700" data-id="element-1047" data-mp="3d2hntqjjdva3">
                          Build 25-bed dormitory and full-service dining hall
                          for 150 people
                        </span>
                      </li>
                      <li className="flex items-start" data-id="element-1048" data-mp="2y7tbptjmryli">
                        <div className="flex-shrink-0 w-6 h-6 rounded-full bg-blue-100 flex items-center justify-center mt-1 mr-3" data-id="element-1049" data-mp="2y71ob606t76b">
                          <span className="text-blue-600 text-sm font-semibold" data-id="element-1050" data-mp="2pf9m1ilbh4ct">
                            3
                          </span>
                        </div>
                        <span className="text-gray-700" data-id="element-1051" data-mp="2kdsnvuu7vvzx">
                          Develop comprehensive curriculum and train instructors
                        </span>
                      </li>
                      <li className="flex items-start" data-id="element-1052" data-mp="2ajtlqvu58c7z">
                        <div className="flex-shrink-0 w-6 h-6 rounded-full bg-blue-100 flex items-center justify-center mt-1 mr-3" data-id="element-1053" data-mp="26h6q0jucq75i">
                          <span className="text-blue-600 text-sm font-semibold" data-id="element-1054" data-mp="1vtp93wps302t">
                            4
                          </span>
                        </div>
                        <span className="text-gray-700" data-id="element-1055" data-mp="1mvdhbrd6dw8s">
                          Fund first-year operations to train 50,000 civilians
                        </span>
                      </li>
                    </ul>
                    <div className="mt-8" data-id="element-1056" data-mp="2fjj56mzj01cu">
                      <div className="bg-blue-50 p-4 rounded-lg" data-id="element-1057" data-mp="2jkcu9jopfm7b">
                        <p className="text-gray-700 font-medium" data-id="element-1058" data-mp="2jjtea8im77vx">
                          Land has been zoned and approved for the center, with
                          infrastructure planning underway and local agreements
                          pending.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </ScrollReveal>
            </div>
          </div>
        </div>
      </ScrollReveal>
      {/* Training Focus Areas */}
      <ScrollReveal animation="fade" data-id="element-1059" data-mp="3cl14gltnrtrn"></ScrollReveal>
      {/* How You Can Help */}
      <ScrollReveal animation="fade" data-id="element-1060" data-mp="38lk05vpyx2o2">
        <div className="py-16 sm:py-24 bg-gray-50" data-id="element-1061" data-mp="3mcxfsykr9gdt">
          <div className="max-w-5xl mx-auto px-4 sm:px-6" data-id="element-1062" data-mp="3mcfbdenxvvut">
            <div className="text-center mb-16" data-id="element-1063" data-mp="3hdu8t8l7t037">
              <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-6 tracking-tight" data-id="element-1064" data-mp="3hg70idgryotg">
                How You Can Help
              </h2>
              <p className="text-xl text-gray-700 max-w-3xl mx-auto" data-id="element-1065" data-mp="2pnpspm4hmz7s">
                Join our mission to protect Israeli civilians through training
                and preparedness
              </p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16" data-id="element-1066" data-mp="2yml2t9anktgd">
              <ScrollReveal animation="slide-up" delay={0.1} data-id="element-1067" data-mp="ivyqa8yjozry">
                <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-100 relative overflow-hidden" data-id="element-1068" data-mp="iykvi1xyr370">
                  <div className="absolute top-0 right-0 w-24 h-24 -mt-8 -mr-8 bg-blue-50 rounded-full" data-id="element-1069" data-mp="2jlnx6p71i63p"></div>
                  <div className="relative" data-id="element-1070" data-mp="2okiqil2mvd22">
                    <div className="w-14 h-14 rounded-full bg-blue-50 flex items-center justify-center mb-6" data-id="element-1071" data-mp="2olai7kt40qn2">
                      <DollarSign className="w-7 h-7 text-blue-500" data-id="element-1072" data-mp="2tik62w0uou8s" />
                    </div>
                    <h3 className="text-xl font-semibold text-gray-900 mb-4" data-id="element-1073" data-mp="2xmrwqyqvck9n">
                      Give
                    </h3>
                    <p className="text-gray-700 mb-6" data-id="element-1074" data-mp="37jmsxazo68kr">
                      Make a tax-deductible donation through our U.S. 501(c)(3)
                      Israeli Civilian Training Fund{' '}
                      <span className="text-sm italic" data-id="element-1075" data-mp="3ccph13logptk"></span> to support
                      immediate training needs and long-term center development.
                    </p>
                    <div className="flex flex-col gap-2 items-start" data-id="element-1076" data-mp="3lculb4vkr83i">
                      <a href="https://donate.stripe.com/7sY5kw7P1eO24x90y314401" target="_blank" rel="noopener noreferrer" className="text-blue-600 font-medium hover:text-blue-700" data-id="element-1077" data-mp="3qb5st8yed6ik">
                        Donate online →
                      </a>
                      <button type="button" onClick={openDonateByMail} className="text-blue-600 font-medium hover:text-blue-700" data-id="element-1078" data-mp="10n9jjnir80sx">
                        Donate by mail →
                      </button>
                    </div>
                  </div>
                </div>
              </ScrollReveal>
              <ScrollReveal animation="slide-up" delay={0.2} data-id="element-1079" data-mp="1jm3usmj0ej4c">
                <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-100 relative overflow-hidden" data-id="element-1080" data-mp="1jllsp99o1aoi">
                  <div className="absolute top-0 right-0 w-24 h-24 -mt-8 -mr-8 bg-blue-50 rounded-full" data-id="element-1081" data-mp="2h32o688nk0lj"></div>
                  <div className="relative" data-id="element-1082" data-mp="2v6rrjoqkwjcg">
                    <div className="w-14 h-14 rounded-full bg-blue-50 flex items-center justify-center mb-6" data-id="element-1083" data-mp="2v82xnv7hy36q">
                      <Building className="w-7 h-7 text-blue-500" data-id="element-1084" data-mp="305cwg1grzr78" />
                    </div>
                    <h3 className="text-xl font-semibold text-gray-900 mb-4" data-id="element-1085" data-mp="2mdogto7bikli">
                      Partner
                    </h3>
                    <p className="text-gray-700 mb-6" data-id="element-1086" data-mp="2qdox7edz95v7">
                      Introduce corporate grants, in-kind equipment donations,
                      or leverage your organizational resources to advance our
                      mission of civilian protection.
                    </p>
                    <a href="/contact" className="text-blue-600 font-medium hover:text-blue-700" data-id="element-1087" data-mp="23hor6k1tbt53">
                      Become a partner →
                    </a>
                  </div>
                </div>
              </ScrollReveal>
              <ScrollReveal animation="slide-up" delay={0.3} data-id="element-1088" data-mp="5nq2i6ly0taj">
                <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-100 relative overflow-hidden" data-id="element-1089" data-mp="1q8o7vyywg8r2">
                  <div className="absolute top-0 right-0 w-24 h-24 -mt-8 -mr-8 bg-blue-50 rounded-full" data-id="element-1090" data-mp="1m7uguwq5udty"></div>
                  <div className="relative" data-id="element-1091" data-mp="1zyzfbvhsl02p">
                    <div className="w-14 h-14 rounded-full bg-blue-50 flex items-center justify-center mb-6" data-id="element-1092" data-mp="1v6fxunfzhksm">
                      <Share2 className="w-7 h-7 text-blue-500" data-id="element-1093" data-mp="29v2lrdjofkvg" />
                    </div>
                    <h3 className="text-xl font-semibold text-gray-900 mb-4" data-id="element-1094" data-mp="24xkd7o9kn7nz">
                      Share
                    </h3>
                    <p className="text-gray-700 mb-6" data-id="element-1095" data-mp="2iw0jje3iuw5l">
                      Host an awareness event, share our story online, or help
                      us connect with others who can support this critical
                      initiative for Israel's security.
                    </p>
                    <a href="/contact" className="text-blue-600 font-medium hover:text-blue-700" data-id="element-1096" data-mp="jkpyrnjskfmf">
                      Spread the word →
                    </a>
                  </div>
                </div>
              </ScrollReveal>
            </div>
          </div>
        </div>
      </ScrollReveal>
      {/* Long-Term Vision */}
      <ScrollReveal animation="fade" data-id="element-1097" data-mp="ce3srzo6i1up">
        <div className="py-16 sm:py-24 bg-white" data-id="element-1098" data-mp="ch9inh4mt7rh">
          <div className="max-w-5xl mx-auto px-4 sm:px-6" data-id="element-1099" data-mp="3bvbrwmory4ck">
            <div className="text-center mb-16" data-id="element-1100" data-mp="3fvvnvmxm31x4">
              <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-6 tracking-tight" data-id="element-1101" data-mp="3fwn8y3tl1h95">
                Our Long-Term Vision
              </h2>
              <p className="text-xl text-gray-700 max-w-3xl mx-auto" data-id="element-1102" data-mp="3pu1qk6r8sc31">
                Building a sustainable network of training centers across Israel
              </p>
            </div>
            <ScrollReveal animation="slide-up" data-id="element-1103" data-mp="1073qtle0a85e">
              <div className="prose prose-lg max-w-none text-gray-700 mb-12" data-id="element-1104" data-mp="152rg00shn1aw">
                <p data-id="element-1105" data-mp="2pmefnnsfuyxo">
                  Our long-term vision extends beyond the initial Samaria
                  Regional Training Center. We aim to establish a network of
                  regional centers strategically located across Israel to ensure
                  all civilians have access to this critical training.
                </p>
                <p data-id="element-1106" data-mp="2awfjtrocvzld">
                  To ensure the sustainability of these centers, we're
                  developing a multi-faceted funding model that includes:
                </p>
              </div>
            </ScrollReveal>
            <div className="space-y-4 mb-16" data-id="element-1107" data-mp="21yn3qlat8nwx">
              <ScrollReveal animation="slide-up" delay={0.1} data-id="element-1108" data-mp="1wy8syvhtqzv7">
                <div className="bg-gray-50 p-6 rounded-lg" data-id="element-1109" data-mp="1ry4f7d8awj8o">
                  <p className="text-gray-700 text-base sm:text-lg" data-id="element-1110" data-mp="1rzxkop76gxf3">
                    Donor Sponsorship Programs – Establish annual and lifetime
                    donation tiers in direct support of the training center.
                  </p>
                </div>
              </ScrollReveal>
              <ScrollReveal animation="slide-up" delay={0.2} data-id="element-1111" data-mp="jgt0hiiam2xm">
                <div className="bg-gray-50 p-6 rounded-lg" data-id="element-1112" data-mp="ehy57h352lwm">
                  <p className="text-gray-700 text-base sm:text-lg" data-id="element-1113" data-mp="ekkcrgq151eu">
                    Corporate Grants – Pursue funding from Israeli focused
                    organizations.
                  </p>
                </div>
              </ScrollReveal>
              <ScrollReveal animation="slide-up" delay={0.3} data-id="element-1114" data-mp="ruo14j49ie1">
                <div className="bg-gray-50 p-6 rounded-lg" data-id="element-1115" data-mp="3rx4baofq7ijy">
                  <p className="text-gray-700 text-base sm:text-lg" data-id="element-1116" data-mp="3rvt4sguwbwp5">
                    Family Sponsorship Program – Enable donators to sponsor
                    individual/specific family members across Israel
                  </p>
                </div>
              </ScrollReveal>
              <ScrollReveal animation="slide-up" delay={0.4} data-id="element-1117" data-mp="1l5d9ndhlxn56">
                <div className="bg-gray-50 p-6 rounded-lg" data-id="element-1118" data-mp="1h4jjedgozw94">
                  <p className="text-gray-700 text-base sm:text-lg" data-id="element-1119" data-mp="1h2ynokin679o">
                    Civilian Scholarships – Civilians training scholarship
                    programs to ensure all civilians can attend.
                  </p>
                </div>
              </ScrollReveal>
              <ScrollReveal animation="slide-up" delay={0.5} data-id="element-1120" data-mp="38t146238ec0t">
                <div className="bg-gray-50 p-6 rounded-lg" data-id="element-1121" data-mp="3cuma13hclq1i">
                  <p className="text-gray-700 text-base sm:text-lg" data-id="element-1122" data-mp="3cw78v5ap3v56">
                    Municipal Sponsorship Program – Utilization of government
                    grants to sponsor training.
                  </p>
                </div>
              </ScrollReveal>
            </div>
          </div>
        </div>
      </ScrollReveal>
      {/* Performance Metrics */}
      <ScrollReveal animation="fade" data-id="element-1123" data-mp="2u4ebkyolfnrn">
        <div className="py-16 sm:py-24 bg-blue-50" data-id="element-1124" data-mp="2u18otq3fsxz3">
          <div className="max-w-5xl mx-auto px-4 sm:px-6" data-id="element-1125" data-mp="4d9gr80kklnf">
            <div className="text-center mb-16" data-id="element-1126" data-mp="9d4451l4yt3q">
              <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-6 tracking-tight" data-id="element-1127" data-mp="9bt0r2vlrnd5">
                Measuring Our Impact
              </h2>
              <p className="text-xl text-gray-700 max-w-3xl mx-auto" data-id="element-1128" data-mp="21f744mkkm1mc">
                Transparent reporting on how your support is making a difference
              </p>
            </div>
            <div className="space-y-6 max-w-3xl mx-auto mb-16" data-id="element-1129" data-mp="2aflsjustzwu2">
              {impactMetrics.map((metric, index) => <ScrollReveal key={index} animation="slide-up" delay={index * 0.1} data-id="element-1130" data-mp="1mphojmbqdv2j" data-mpi={index}>
                  <div className="flex items-start" data-id="element-1131" data-mp="1hsr6wuka2rf0">
                    <div className="flex-shrink-0 w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center mt-1 mr-4" data-id="element-1132" data-mp="1wg3x4wl15lbq">
                      <span className="text-blue-600 font-semibold" data-id="element-1133" data-mp="1rnj9ydwmq6h6">
                        {index + 1}
                      </span>
                    </div>
                    <div className="bg-white p-5 rounded-lg shadow-sm border border-gray-100 flex-grow" data-id="element-1134" data-mp="z0yhtb8bxqck">
                      <p className="text-gray-700" data-id="element-1135" data-mp="3anjtavclcmho">{metric}</p>
                    </div>
                  </div>
                </ScrollReveal>)}
            </div>
            <ScrollReveal animation="fade" delay={0.3} data-id="element-1136" data-mp="31n3q7mzrfhdc">
              <div className="text-center" data-id="element-1137" data-mp="31oop1ot3xmh0">
                <p className="text-gray-700 mb-8" data-id="element-1138" data-mp="35oflo95bewtg">
                  A comprehensive dashboard will publish these metrics annually
                  to ensure transparency and accountability to our supporters.
                </p>
                <div className="flex flex-wrap justify-center gap-4" data-id="element-1139" data-mp="26xe82tgfrtk">
                  <a href="https://donate.stripe.com/7sY5kw7P1eO24x90y314401" target="_blank" rel="noopener noreferrer" className="inline-block px-8 py-4 bg-israel-blue text-white font-semibold rounded-lg border-2 border-israel-blue hover:bg-israel-blue-light transition-colors text-lg shadow-lg" data-id="element-1140" data-mp="3kdv8xf5n0k4e">
                    Donate Online
                  </a>
                  <button type="button" onClick={openDonateByMail} className="inline-block px-8 py-4 bg-white text-israel-blue font-semibold rounded-lg border-2 border-israel-blue hover:bg-gray-50 transition-colors text-lg" data-id="element-1141" data-mp="2t8r34uut3bus">
                    Donate by Mail
                  </button>
                </div>
              </div>
            </ScrollReveal>
          </div>
        </div>
      </ScrollReveal>
    </div>;
};
const fundingModel = ['Donor Sponsorship Programs — Establish annual and lifetime donation tiers with appropriate recognition.', 'Corporate Grants — Pursue funding from Israeli-focused organizations and foundations committed to security.', 'Revenue-Generating Training Programs — Offer specialized training for law enforcement and security professionals to subsidize free civilian courses.', 'Civilian Training Scholarship Programs — Ensure all civilians can attend regardless of financial means.', 'Subscription-Based Learning Modules — Develop online courses for remote education and ongoing skill maintenance.'];
const impactMetrics = ['Civilians in need of training 400k. Projected civilians trained 50k per year.', 'Self-defense and emergency response evaluation scores to measure training effectiveness', 'Incident response evaluations and post-training impact assessments', "Ongoing family training to enhance Israel's national security with emerging threats", 'Community resilience indicators and security readiness measurements'];
export default SupportPage;